<template>
  <div class="task-wrapper">
    <div class="wrapper-local project-box box df fdr"
          v-on:click="stopProp($event)"
          v-closable="{
            handler: 'closeIt'
          }">
      <div class="one-row df fdr min-width-1">
        <div class="profile-photo-image posrel">
          <img
            class="profile-image"
            v-bind:src="$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].taskImage || '/images/Default-Task-Image.png'"
            alt=""
          >
          <img v-on:click="uploadPhotoStart()" src="/images/profile-icons/Edit-Profile-Pen.png" class="posabs edit-profile-icon" alt="" v-if="editable">
          <input v-on:change="uploadPhotoContinue()" ref="fileInput" v-bind:id="'fileUploadButton' + taskIndex" style="opacity: 0; width: 0; height: 0; position: absolute;" type="file" />
        </div>
        <div class="half-width df fdr aic ml1">
          <input type="text" class="input0 w100p" v-model="taskName" v-on:change="saveThisTask()" :disabled="!editable">
        </div>
      </div>
      <div class="one-row df fdr">
        <div class="df fdc f1 aic jcc task-toggles">
          <span class="df w100p">
            <img v-if="taskFullType == 'hourlyElements'" src="/images/Price-Blue.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
            <img v-else src="/images/Price-Grey.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
            <p class="default-task" v-on:click="flipTaskType()">Hourly Rate</p>
          </span>
          <span class="df w100p">
            <img v-if="taskFullType == 'percentTasks'" src="/images/Percentage-Blue.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
            <img v-else src="/images/Percentage-Grey.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
            <p class="use-rate-text" v-on:click="flipTaskType()">Variable Rate</p>
          </span>
        </div>
      </div>
      <div class="one-row aic">
        <span class="input-wrapper rate-cost-inputs">
          <p class="float-label">Rate</p>
          <p class="float-addition1">{{ taskFullType == 'hourlyElements' ? '/h' : '' }}</p>
          <p class="float-addition2">$</p>
          <input type="number" class="input1" v-model="taskRate" v-on:change="saveThisTask()" v-on:keypress="validateInputValue" :disabled="!editable">
        </span>
      </div>
      <div class="one-row aic ml1">
        <span class="input-wrapper rate-cost-inputs">
          <p class="float-label">Cost</p>
          <p class="float-addition1">{{ taskFullType == 'hourlyElements' ? '/h' : '' }}</p>
          <p class="float-addition2">$</p>
          <input type="number" class="input1" v-model="taskCost" v-on:change="saveThisTask()" v-on:keypress="validateInputValue" :disabled="!editable">
        </span>
      </div>
      <div class="one-row aic ml1">
        <span v-if="taskFullType == 'percentTasks'" v-on:input="dataHasBeenEdited()" class="input-wrapper rate-cost-inputs">
          <p class="float-label">Percentage</p>
          <p class="float-addition1">%</p>
          <p class="float-addition2"></p>
          <input type="number" class="input1" v-model="taskPercent" v-on:change="saveThisTask()" v-on:input="dataHasBeenEdited()" v-on:keypress="validateInputValue" >
        </span>
      </div>
      <div class="one-row df fdr ml1">
        <div class="df fdc f1 aic jcc task-toggles">
          <span class="df w100p">
            <img v-if="useRate" src="/images/Icon-Selected.svg" alt="" v-on:click="flipUseRate()">
            <span v-else alt="" class="use-rate" v-on:click="flipUseRate()"></span>
            <p class="use-rate-text" v-on:click="flipUseRate()">Use Task Rate</p>
          </span>
          <span class="df w100p">
            <img v-if="useCost == true" class="use-cost-selected" src="/images/Icon-Selected.svg" alt="" v-on:click="flipUseCost()">
            <span v-else alt="" class="use-cost" v-on:click="flipUseCost()"></span>
            <p class="use-cost-text" v-on:click="flipUseCost()">Use Task Cost</p>
          </span>
        </div>
      </div>
    </div>
    <img v-if="editable" class="more-button" src="/images/DeleteIcon.png" v-on:click="deleteColumn()"/>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ProjectTask',
  data () {
    return {
      dataEdited: false,
      taskPercent: this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].taskPercentOverride || null,
      taskRate: this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].hourlyRateOverride || null,
      taskCost: this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].hourlyCostOverride || null,
      taskName: this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].name || null,
      useCost: this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].useTaskCost || null,
      useRate: this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].useTaskRate || null,
      taskFullType: this.taskType,
      showMenu: false
    }
  },
  props: ['taskType', 'taskIndex'],
  watch: {
    // myProp: function(valNew, valOld){
    //   console.log('THIRD - watch - myProp - ', valNew, ' ', valOld)
    // }
  },
  components: {

  },
  methods: {
    validateInputValue(e) {
      e = e || window.event;
      let keyCode = e.which || e.keyCode;
      if((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    stopProp (e) {
      e.stopPropagation()
    },
    closeIt () {
      // this.$emit('closeTaskCard')
    },
    dataHasBeenEdited () {
      this.dataEdited = true
    },
    dataNotEdited () {
      this.dataEdited = false
    },
    removePhoto () {
      var data = {
        projectid: this.$route.params.projectid,
        section: this.taskType,
        index: this.taskIndex
      }
      this.$store.dispatch('deleteTaskPhoto', data).then(() => {
        console.log('After deleting photo')
      })
    },
    uploadPhotoStart () {
      console.log('start photo upload')
      this.$refs.fileInput.click()
    },
    uploadPhotoContinue () {
      console.log('continue uploading photo')
      var inputElement = document.getElementById('fileUploadButton' + this.taskIndex)
      var fileList = inputElement.files
      if (fileList[0]) {
        console.log('THE FILE', fileList[0])
        if ((fileList[0].type == 'image/png') || (fileList[0].type == 'image/jpg') || (fileList[0].type == 'image/jpeg')) {
          var data = {
            file: fileList[0],
            projectid: this.$route.params.projectid,
            section: this.taskType,
            index: this.taskIndex
          }
          console.log('file exists')
          this.$store.dispatch('saveTaskImage', data).then(() => {
            console.log('after saveTaskImage')
          })
        } else {
          console.log('file is wrong type')
        }
      }
    },
    deleteColumn () {
      var data = {
        phases: this.$store.getters.currentProjectPhases,
        projectid: this.$route.params.projectid,
        section: this.taskType,
        index: this.taskIndex
      }
      this.$store.dispatch('deleteColumn', data)
    },
    flipUseRate () {
      if (!this.editable) {
        return
      }
      this.dataHasBeenEdited()
      if (this.useRate == true) {
        this.useRate = null
      } else {
        this.useRate = true
      }
      this.saveThisTask()

      setTimeout(() => {
        if (this.$refs.useRate2) {
          console.log('2', this.$refs.useRate2)
          if (!this.useRate) {
            console.log('2b', this.$refs.useRate2)
            this.$refs.useRate2.focus()
          }
        }
        if (this.$refs.useRate1) {
          console.log('1', this.$refs.useRate1)
          if (this.useRate) {
            console.log('1b', this.$refs.useRate1)
            this.$refs.useRate1.focus()
          }
        }
      }, 50)
    },
    flipUseCost () {
      if (!this.editable) {
        return
      }
      this.dataHasBeenEdited()
      if (this.useCost == true) {
        this.useCost = null
      } else {
        this.useCost = true
      }
      this.saveThisTask()

      setTimeout(() => {
        if (this.$refs.useCost2) {
          console.log('2', this.$refs.useCost2)
          if (!this.useCost) {
            console.log('2b', this.$refs.useCost2)
            this.$refs.useCost2.focus()
          }
        }
        if (this.$refs.useCost1) {
          console.log('1', this.$refs.useCost1)
          if (this.useCost) {
            console.log('1b', this.$refs.useCost1)
            this.$refs.useCost1.focus()
          }
        }
      }, 50)
    },
    flipTaskType () {
      if (!this.editable) {
        return
      }
      this.dataHasBeenEdited()
      if (this.taskFullType == 'hourlyElements') {
        this.taskFullType = 'percentTasks'
      } else if (this.taskFullType == 'percentTasks') {
        this.taskFullType = 'hourlyElements'
      }
      const a = this.$store.getters.currentProjectModuleColumns[this.taskFullType]
      this.saveThisTask()
      this.$emit('openNewCard', this.taskFullType, a ? a.length : 0)

    },
    deleteThisTask () {
    },
    saveThisTask () {
      var data = {
        projectid: this.$route.params.projectid,
        taskindex: this.taskIndex,
        taskPercentOverride: this.taskPercent,
        hourlyRateOverride: this.taskRate,
        hourlyCostOverride: this.taskCost,
        name: this.taskName,
        useTaskCost: this.useCost,
        useTaskRate: this.useRate,
        taskTypeNew: this.taskFullType,
        taskTypeStart: this.taskType,
        taskPercent: this.taskPercent,
        test: this.$store.getters.currentProjectModuleColumns
      }
      this.$store.dispatch('changeTaskDetails', data).then(() => {
        console.log('after changeTaskDetails')
        this.dataNotEdited()
      })
    },
    emitCloseClick () {
      this.$emit('closeTaskCard')
      this.cancelEdits()
    },
    cancelEdits () {
      this.taskPercent = this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].taskPercentOverride || null
      this.taskRate = this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].hourlyRateOverride || null
      this.taskCost = this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].hourlyCostOverride || null
      this.taskName = this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].name || null
      this.useCost = this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].useTaskCost || null
      this.useRate = this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex].useTaskRate || null
      this.taskFullType = this.taskType
    }
  },
  computed: {
    ...mapGetters(['userRole']),
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    },
    columns () {
      return this.$store.getters.currentProjectModuleColumns
    }
  },
  watch: {
    columns (newVal, oldVal) {
      // console.log(newVal, oldVal)
      // this.cancelEdits()
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      console.log('mounted')
    })
  },
  updated: function () {
    this.$nextTick(function () {
      console.log('updated')
      // Code that will run only after the
      // entire view has been re-rendered
    })
  },
  created () {
    setTimeout(()=>{
      if (this.$refs.valueInput) {
        this.$refs.valueInput.select()
        if (this.$refs.valueInput[0]) {
          this.$refs.valueInput[0].select()
        }
      }
    }, 50)
    // console.log('** Project Task Component Loaded', this.$store.getters.currentProjectModuleColumns[this.taskType][this.taskIndex])
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";

.task-wrapper{
  position: relative;
}
.project-pricing-modal {

  .task-modal {
    .task-wrapper {
      .project-box  {
        margin-bottom: 0px;
      }
    }
  }
}
.project-box {
  padding: 35px 5px;
  margin-bottom: 35px;

  // div
  & > div {
    position: relative;
    min-width: unset;
    width: 20%;
    margin-left: 0px;
    padding-left: 30px;
    padding-right: 30px;
    &:after {
      content: '';
      width: 1px;
      height: 44px;
      background-color: #dfdfdf;
      top: 50%;
      transform: translateY(-50%);
      right: 0px;
      position: absolute;
    }
    &:first-child {
      flex: none;
      width: 300px;
      &:after {
        display: none;
      }
    }
    &:nth-child(2) {
      flex: none;
      width: 180px;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
    input {
      width: 100%;
      max-width: unset;
      margin-right: 0px;
    }
  }

  // Responsive Style
  // @media max-width: 1080px
  @media(max-width: 1080px) {
    flex-wrap: wrap;

    // div
    > div {
      width: 25%;
      margin-bottom: 15px;
      &:nth-child(1) {
        width: 100%;
      }
      &:nth-child(2) {
        width: 25%;
      }
      &:nth-child(5){
        &:after {
          display: none;
        }
      }
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding-left: 25px;
    padding-right: 25px;
    margin-bottom: 20px;

    // div
    > div {
      width: 50%;
      padding-left: 0px;
      padding-right: 0px;
      border-bottom: 1px solid #DFDFDF;
      padding-bottom: 15px;
      &:after {
        display: none;
      }
      &:nth-child(1) {
        border-bottom: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
        .half-width {width: 100%;}
      }
      &:nth-child(2) {
        flex-direction: unset;
        width: 100%;
        margin-bottom: 30px;
        .task-toggles {
          flex-wrap: wrap;
          justify-content: unset;
          flex-direction: unset;
          > span {
            width: 50%;
            margin-right: 0px;
          }
        }
      }
      &:nth-child(3) {
        padding-right: 12.5px;
      }
      &:nth-child(4) {
        padding-left: 12.5px;
      }
      &:nth-child(5) {
        width: 100%;
        border-bottom: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
      }
    }
  }
}


//
// One Row
.one-row {
  display: flex;
}


.half-width {
  width: 50%;
}
.input-wrapper {
  position: relative;
  display: block;
  width: 100%;
}
.float-label {
  position: absolute;
  top: -2px;
  transform: translateY(-100%);
  font-size: 14px;
  font-weight: 600;
}
.input-grey {
  padding: 20px;
  padding-right: 2px;
  height: 65px;
  border-radius: 5px;
  background-color: #F5F5F5;
  border: 0;
  font-size: 18px;
  letter-spacing: 0.64px;
  line-height: 25px;
}

.w25p {
  margin-right: 20px;
  width: calc(25% - 20px);
}

.w50p {
  margin-right: 20px;
  width: calc(50% - 20px);
}

.w100p {
  /*margin-right: 20px;*/
  /*width: calc(100% - 20px);*/
}
.input-grey {
  width: 100%;
}
.thirdButton {
  margin-right: 20px;
  width: calc(33.33% - 20px);
}
.button-white {
  background-color: white;
}
.float-addition1 {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.float-addition2 {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}
.button-small {
  padding: 8px 12px;
  margin-left: 15px;
}
.task-type {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  /*background-color: white;*/
  text-transform: capitalize;

  &:focus {
    background-color: $primaryColorDarker;
  }

  & > img {
    margin-right: 15px;
    height: 30px;
    width: 30px;
  }
}
.task-image {
  background-color: #eee;
  border-radius: 50%;
  height: 80px;
  width: 80px;
}
.use-cost-selected, .use-cost {
  /*margin-left: 35px;*/
}
.use-cost-selected, .use-rate-selected, .use-cost, .use-rate {
  height: 13px;
  width: 13px;
  border: 1px solid $primaryColor;
  border-radius: 50%;
}
.use-cost-selected, .use-rate-selected {
  border: 0;
}
.use-cost, .use-rate {
  background-color: #eee;

  &:focus {
    /*background-color: $primaryColorDarker;*/
    border: 2px solid $primaryColor;
  }
}

.use-rate-text, .use-cost-text {
  margin-left: 10px;
}

.selectable-icon {
  border-radius: 50%;
  box-sizing: border-box;
}
.selectable-icon:focus {
  /*opacity: 0.8;*/
  border: 2px solid $primaryColor;
}
.use-rate-text, .use-cost-text {
  margin-left: 10px;
}
.default-task {
  margin-left: 10px;
}
.task-toggles {
  min-width: 150px;

  & > span {
    -ms-align-items: center;
    align-items: center;
  }
  .bigger-icons {
    height: 24px;
    width: 24px;
    border: none;
  }

  & > span:nth-of-type(2) {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  & > span > img {
    height: 13px;
    width: 13px;
    border: 1px solid $primaryColor;
    border-radius: 50%;
  }

  color: $grey2;
  font-family: 'GG';
  font-size: 12px;
}
.company-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
}
.ml1 {
  margin-left: 30px;
}

.mr1 {
  margin-right: 30px;
}

.vertical-divider {
  align-self: center;
  width: 1px;
  min-width: 1px;
  height: 44px;
  background: $grey4;
}

.min-width-1 {
  min-width: 240px;
  width: 240px;
}

.input0 {
  width: 90px;
  max-width: 90px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.more-button{
  position: absolute;
  right: 15px;
  bottom: 15px;
  cursor: pointer;
}
</style>
